class QuotationResultAnnualConsumptionComponent {
    /** @ngInject */
    constructor(DeviceChecker) {
        this.isMobile = DeviceChecker.isMobile
    }

    getAmountPerMonth(amount) {
        return Math.floor(Math.floor(amount * 100) / 12) / 100
    }

    openTimeline() {
        this.onDispatch({ $event: { type: 'GO_TO_STATE_TIMETABLE', origin: 'RESULT_ANNUAL_CONSUMPTION_BTN_TIMETABLE' } })
    }
}

export default {
    template: require('./quotationResultAnnualConsumption.jade')(),
    controller: QuotationResultAnnualConsumptionComponent,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationResultAnnualConsumption.js